// extracted by mini-css-extract-plugin
module.exports =  {"container":"_02712f2b3b--container--Woze7","icon":"_02712f2b3b--icon--IKO1G","icon--inner":"_02712f2b3b--icon--inner--sAM5W","tooltip":"_02712f2b3b--tooltip--pHDMN"};